import { FilterDef } from "@/stores/filters/FilterDef.ts";

export class GoalCollectionFilterDef extends FilterDef
{
	constructor() {
		super([
			'archived',
			'curriculum'
		]);
	}

	set archived(archived: boolean) {
		this.setParamValue('archived', archived ? '1' : '0');
	}

	get archived(): boolean {
		return this.getParamValues('archived')[0]?.id === '1';
	}

	set curriculum(curriculum: string | null) {
		if (!curriculum) {
			this.clearParam('curriculum');
			return;
		}
		this.setParamValue('curriculum', curriculum);
	}

	get curriculum(): string | null {
		return this.getParamValues('curriculum')[0]?.id ?? null;
	}
}
